// extracted by mini-css-extract-plugin
module.exports = {"accountCard":"DropdownCard_accountCard__1RGwd"};